import { render, staticRenderFns } from "./GpTabHeader.vue?vue&type=template&id=2b0813be&scoped=true&"
import script from "./GpTabHeader.vue?vue&type=script&lang=js&"
export * from "./GpTabHeader.vue?vue&type=script&lang=js&"
import style0 from "./GpTabHeader.vue?vue&type=style&index=0&id=2b0813be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0813be",
  null
  
)

export default component.exports